import React from 'react';
import { Property, UserRole } from '../../../types';
import { MapPinIcon, FireIcon } from '../../Icons';

interface Props {
  formData: Partial<Property>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  availableOwners: string[];
  cityOptions: string[];
  localityOptions: string[];
  neighborhoodOptions: string[];
}

export const CreatePropertyBasicFields: React.FC<Props> = ({
  formData,
  onChange,
  availableOwners,
  cityOptions,
  localityOptions,
  neighborhoodOptions,
}) => {
  const inputClass = 'mt-1 block w-full px-3 py-2 border-2 border-gray-100 rounded-xl text-xs font-bold focus:border-sky-500 outline-none transition-all appearance-none bg-white';
  const labelClass = 'text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1 block';

  return (
    <section className="space-y-4">
      <div className="flex justify-between items-center bg-indigo-50/50 p-4 rounded-2xl border border-indigo-100">
        <div className="flex items-center gap-3">
          <FireIcon className="w-5 h-5 text-indigo-600" />
          <div>
            <h4 className="text-xs font-black uppercase text-indigo-900">Preventa Exclusiva</h4>
            <p className="text-[10px] text-indigo-500 font-bold">Activar etiqueta de preventa</p>
          </div>
        </div>
        <label className="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" name="es_preventa" checked={!!formData.es_preventa} onChange={onChange} className="sr-only peer" />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
        </label>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className={labelClass}>Código del Inmueble *</label>
          <input type="text" name="codigo" value={formData.codigo || ''} onChange={onChange} placeholder="183150-12345" className={inputClass} required />
        </div>
        <div>
          <label className={labelClass}>Dueño / Propietario *</label>
          <select name="owner" value={formData.owner || ''} onChange={onChange} className={inputClass} required>
            <option value="">Seleccionar...</option>
            {availableOwners.map((o) => (
              <option key={o} value={o}>{o.replace(/_/g, ' ')}</option>
            ))}
          </select>
        </div>
        <div>
          <label className={labelClass}>Tipo de Inmueble</label>
          <select name="tipoinmueble" value={formData.tipoinmueble || 'Apartamento'} onChange={onChange} className={inputClass}>
            {['Apartamento', 'Casa', 'Apartaestudio', 'Oficina', 'Local', 'Bodega', 'Lote', 'Finca'].map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className={labelClass}>Ciudad</label>
          <select name="ciudad" value={formData.ciudad || ''} onChange={onChange} className={inputClass}>
            {cityOptions.map((c) => (<option key={c} value={c}>{c}</option>))}
          </select>
        </div>
        <div>
          <label className={labelClass}>Localidad</label>
          <select name="localidad" value={formData.localidad || ''} onChange={onChange} className={inputClass}>
            <option value="">Seleccionar...</option>
            {localityOptions.map((l) => (<option key={l} value={l}>{l}</option>))}
          </select>
        </div>
        <div>
          <label className={labelClass}>Barrio</label>
          <select name="neighborhoodName" value={(formData as any).neighborhoodName || ''} onChange={onChange} className={inputClass}>
            <option value="">Seleccionar...</option>
            {neighborhoodOptions.map((n) => (<option key={n} value={n}>{n}</option>))}
          </select>
        </div>
      </div>

      <div>
        <label className={labelClass}>Dirección Exacta</label>
        <div className="relative">
          <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input type="text" name="direccion" value={formData.direccion || ''} onChange={onChange} className={`${inputClass} pl-9`} placeholder="Calle 123 # 45-67" />
        </div>
      </div>
    </section>
  );
};
